import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import ContentHeading from '../content-heading';
import CC from '../../scripts/combine-classes';
import classes from '../../styles/portfolio.module.css';
import bClasses from '../../components/forms/button.module.css';

type ArticleProps = {
  articleName?: string,
  children: ReactNode,
  externalUrl?: boolean,
  title: string,
  type?: string | null,
  url?: string | null,
}

const Article = ({
  articleName,
  children,
  externalUrl = false,
  title,
  type,
  url,
}: ArticleProps) => {
  return (
    <article>
      <ContentHeading
        title={title}
        type={type}
      >
        {url && !externalUrl && (
          <Link
            to={url}
            className={CC(
              classes.h2Button,
              bClasses.button,
              bClasses.primary,
            )}
          >
            View {articleName}
          </Link>
        )}
        {url && externalUrl && (
          <a
            href={url}
            rel="noreferrer"
            target="_blank"
          >
            {url}
          </a>
        )}
      </ContentHeading>

      {children}
    </article>
  );
};

export default Article;
